/**
 * @param date to be transformed
 * @returns date in the format YYYY-MM-DD
 */
export function dateToStandardFormat(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
}
